export default __webpack_public_path__ + "static/media/GChurchillClosed.2c2d273a.jpg";